export const getEnabledTab = (tab: number, tabs: string[] = [], disabledTabs?: number[]) => {
    const existingTabIndex = tabs.length > tab ? tab : 0;

    if (disabledTabs?.includes(existingTabIndex)) {
        const enabledTab = tabs.find((_, index) => !disabledTabs.includes(index));

        return tabs.indexOf(enabledTab);
    }

    return existingTabIndex;
};
